import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import config from "../../utils/config";
import { ImageValidation } from "../Validation/ImageValidation";
import Rejectreason from "./Rejectreason";
import { useKycPassportVerifyMutation } from "../../redux/kycApi";

const { imageUrl } = config;

function Passport({ kycTrack, refetch }) {
  const [passportNumber, setPassportNumber] = useState("");
  const [passportFront, setPassportFront] = useState("");
  const [passportBack, setPassportBack] = useState("");
  const [previewFront, setPreviewFront] = useState("/assets/img/icon2.png");
  const [previewBack, setPreviewBack] = useState("/assets/img/icon2.png");
  const [passportNumberError, setPassportNumberError] = useState("");
  const [passportFrontError, setPassportFrontError] = useState("");
  const [passportBackError, setPassportBackError] = useState("");
  const [rejectionReason, setRejectionReason] = useState("");
  const [btnDisable, setBtnDisable] = useState(false);

  const [kycPassportVerify] = useKycPassportVerifyMutation();

  const status = kycTrack?.progress?.passport_verification?.status;
  const isEditable = status === "pending" || status === "rejected";
  const passportData = kycTrack?.progress?.passport_verification?.data;

  useEffect(() => {
    const loadImageAsFile = async (url, filename) => {
      try {
        const res = await fetch(url);
        const blob = await res.blob();
        return new File([blob], filename, { type: blob.type });
      } catch (err) {
        console.error("Failed to convert image URL to File:", err);
        return null;
      }
    };

    if (passportData) {
      setPassportNumber(passportData.passport_number || "");
      setRejectionReason(passportData.reason || "");

      const frontSource = passportData.front_image || passportData.image;
      if (frontSource) {
        const frontUrl = imageUrl + frontSource;
        setPreviewFront(frontUrl);
        loadImageAsFile(frontUrl, "passport_front.jpg").then((file) => {
          if (file) setPassportFront(file);
        });
      }

      if (passportData.back_image) {
        const backUrl = imageUrl + passportData.back_image;
        setPreviewBack(backUrl);
        loadImageAsFile(backUrl, "passport_back.jpg").then((file) => {
          if (file) setPassportBack(file);
        });
      }
    }
  }, [passportData]);

  const handleNumberChange = (e) => {
    const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
    setPassportNumber(value);

    if (!value) {
      setPassportNumberError("This field is required");
    } else if (value.length < 6 || value.length > 20) {
      setPassportNumberError("Passport number must be 6 to 20 characters");
    } else {
      setPassportNumberError("");
    }
  };

  const handleImageChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];
    if (!file) return;

    const error = ImageValidation(
      name === "front" ? "Passport front" : "Passport back",
      file
    );
    if (error) {
      if (name === "front") setPassportFrontError(error);
      else setPassportBackError(error);
      return;
    }

    if (name === "front") {
      if (passportBack) {
        if (
          passportBack.name === file.name ||
          passportBack.size === file.size
        ) {
          setPassportFrontError("Front image cannot be same as back image");
          return;
        }
      }
      setPassportFrontError("");
      setPassportFront(file);
      setPreviewFront(URL.createObjectURL(file));
    } else {
      if (passportFront) {
        if (
          passportFront.name === file.name ||
          passportFront.size === file.size
        ) {
          setPassportBackError("Back image cannot be same as front image");
          return;
        }
      }
      setPassportBackError("");
      setPassportBack(file);
      setPreviewBack(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async () => {
    if (!passportNumber || !passportFront || !passportBack) {
      setPassportNumberError(!passportNumber ? "This field is required" : "");
      setPassportFrontError(!passportFront ? "This field is required" : "");
      setPassportBackError(!passportBack ? "This field is required" : "");
      return;
    }

    if (passportNumberError || passportFrontError || passportBackError) {
      return;
    }

    setBtnDisable(true);
    setTimeout(() => setBtnDisable(false), 3000);

    const formData = new FormData();
    formData.append("passport_number", passportNumber);
    formData.append("front", passportFront);
    formData.append("back", passportBack);

    const { data, error: apiError } = await kycPassportVerify(formData);

    if (apiError) {
      toast.error(apiError?.data?.message || "Submission failed");
      return;
    }
    if (data) {
      toast.success(data.message || "Submitted successfully");
      refetch();
    } else {
      toast.error(data?.message || "Unexpected error");
    }
  };

  return (
    <div className="passport-outer">
      <div className="">
        {/* <div className="col-md-3 col-12"></div> */}
        <div className="">
          <div className="white_box">
            <h6 className="position-relative">Passport Verification</h6>
            <b className="mt-0">Requirements</b>
            <ul className="dit_ul mb-4">
              <li>The photo/scan must be clear, in color and uncompressed.</li>
              <li>The photo/scan must be not edited and not cropped.</li>
              {/* <li>
                The document must be valid at least 3 months after the
                verification submission date.
              </li> */}
              <li>
                The full name and date of birth you provided in the "Personal
                information" section
              </li>
              <li>should exactly match the ones in your document.</li>
              <li>Min size 10 Kb / Max size 2 Mb.</li>
            </ul>

            <div className="row">
              <div className="form-group col-lg-6 col-md-6">
                <label>Passport Number</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Passport Number"
                  name="passportNumber"
                  value={passportNumber}
                  onChange={handleNumberChange}
                  disabled={!isEditable}
                />
                {passportNumberError && (
                  <div className="text-danger">{passportNumberError}</div>
                )}
              </div>
            </div>

            <div className="row">
              <div className="form-group col-lg-4 col-md-6">
                <div id="file-upload-form" className="uploader mt-3">
                  <input
                    type="file"
                    id="passportFront"
                    accept="image/*"
                    name="front"
                    onChange={handleImageChange}
                    disabled={!isEditable}
                  />
                  <label htmlFor="passportFront" id="file-drag">
                    <img
                      src={previewFront}
                      className="img-fluid22"
                      alt="Passport front"
                    />
                    <div id="start">
                      <span className="fasi"></span>
                      <div>Upload Passport Front</div>
                      <div id="notimage" className="hidden">
                        Please select an image
                      </div>
                    </div>
                    <div id="response" className="hidden">
                      <div id="messages"></div>
                      <progress
                        className="progress"
                        id="file-progress"
                        value="0"
                      >
                        <span>0</span>%
                      </progress>
                    </div>
                  </label>
                </div>
                {passportFrontError && (
                  <div className="text-danger">{passportFrontError}</div>
                )}
              </div>

              <div className="form-group col-lg-4 col-md-6">
                <div id="file-upload-form" className="uploader mt-3">
                  <input
                    type="file"
                    id="passportBack"
                    accept="image/*"
                    name="back"
                    onChange={handleImageChange}
                    disabled={!isEditable}
                  />
                  <label htmlFor="passportBack" id="file-drag">
                    <img
                      src={previewBack}
                      className="img-fluid22"
                      alt="Passport back"
                    />
                    <div id="start">
                      <span className="fasi"></span>
                      <div>Upload Passport Back</div>
                      <div id="notimage" className="hidden">
                        Please select an image
                      </div>
                    </div>
                    <div id="response" className="hidden">
                      <div id="messages"></div>
                      <progress
                        className="progress"
                        id="file-progress"
                        value="0"
                      >
                        <span>0</span>%
                      </progress>
                    </div>
                  </label>
                </div>
                {passportBackError && (
                  <div className="text-danger">{passportBackError}</div>
                )}
              </div>
            </div>

            <p className="mt-0">
              *only jpeg, jpg & png files supported <br />
              *For changing image, click on image upload section again.
            </p>

            <Rejectreason reason={rejectionReason} status={status} />

            {isEditable && (
              <button
                className="btn btn_man w100px"
                onClick={handleSubmit}
                disabled={btnDisable}
              >
                {status === "pending" ? "Submit" : "Re-submit"}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Passport;
